import Promise from "promise";
import {get} from 'lodash';
import {firebaseDb, firebaseApp} from "../../firebase";
import { search } from '../../config';
import {LOG_OUT} from '../auth/actions';

const axios = require('axios').default;

export const GET_ISSUES_LIST_REQUEST = "GET_ISSUES_LIST_REQUEST";
export const GET_ISSUES_LIST_SUCCESS = "GET_ISSUES_LIST_SUCCESS";
export const GET_ISSUES_LIST_FAILURE = "GET_ISSUES_LIST_FAILURE";

export const GET_ISSUE_REQUEST = "GET_ISSUE_REQUEST";
export const GET_ISSUE_SUCCESS = "GET_ISSUE_SUCCESS";
export const GET_ISSUE_FAILURE = "GET_ISSUE_FAILURE";

export const ISSUE_STATE_CLOSED = 100;
export const ISSUE_STATE_RESOLVED = 200;
export const ISSUE_STATE_OPENED = 300;

export const GET_ISSUES_LIST_BY_ID_SUCCESS = "GET_ISSUES_LIST_BY_ID_SUCCESS";
export const NO_USER_PROFILE = "NO_USER_PROFILE";

export const SET_PROJECT_ID = "SET_ISSUE_PROJECT_ID";

export const ISSUES_PDF_REQUEST = 'ISSUES_PDF_REQUEST';
export const ISSUES_PDF_SUCCESS = 'ISSUES_PDF_SUCCESS';
export const ISSUES_PDF_FAILURE = 'ISSUES_PDF_FAILURE';


export const SUBSCRIBE_TO_ISSUE = "SUBSCRIBE_TO_ISSUE";
export const CLEAR_AND_UNSUBSCRIBE_FROM_ISSUES = "CLEAR_AND_UNSUBSCRIBE_FROM_ISSUES";

const removeEmpty = (obj) => {
  Object.keys(obj).forEach(key =>
    (obj[key] && typeof obj[key] === 'object') && removeEmpty(obj[key]) ||
    (obj[key] == null) && delete obj[key]
  );
  return obj;
};

export const subscribeToIssuesByIds = ({projectId, hits}) => (dispatch, getState) => {
  const issuesList = getState().issue.issuesList;

  Object.values(issuesList).forEach(issue => {
    if (issue) {
      firebaseDb.ref(`/posts/${projectId}/${issue.id}`).off("value");
    }
  })

  const issueIds = hits.map(h => h.id);

  issueIds.forEach(issueId => {
    firebaseDb.ref(`/posts/${projectId}/${issueId}`).off("value");
    firebaseDb.ref(`/posts/${projectId}/${issueId}`).on("value", snapshot => {
      const issue = snapshot.val();

      if (issue) {
        dispatch({type: SUBSCRIBE_TO_ISSUE, payload: {issue: snapshot.val(), projectId, issueIds}});
      }
    });
  });

};


export const clearIssues = ({projectId}) => (dispatch, getState) => {
  const issuesList = getState().issue.issuesList;

  Object.values(issuesList).forEach(issue => {
    if (issue) {
      firebaseDb.ref(`/posts/${projectId}/${issue.id}`).off("value");
    }
  })

  dispatch({type: CLEAR_AND_UNSUBSCRIBE_FROM_ISSUES});
};



export const getIssuesByProjectId = projectId => dispatch => {
  firebaseDb.ref(`/posts/${projectId}`).once("value", snapshot => {
    dispatch({type: GET_ISSUES_LIST_SUCCESS, payload: snapshot.val()});
  });
};

export const getIssuesByProjectIdListener = projectId => dispatch => {
  firebaseDb.ref(`/posts/${projectId}`).on("value", snapshot => {
    dispatch({type: GET_ISSUES_LIST_SUCCESS, payload: snapshot.val()});
  });
};

export const getIssuesListByProject = (projectId, issueIds) => dispatch => {
  const promises = issueIds.map(issueId =>
    firebaseDb.ref(`/posts/${projectId}/${issueId}`).once("value")
  );

  let values = {};
  Promise.all(promises).then(results => {
    results.forEach(result => {
      values[result.key] = result.val();
    });

    dispatch({type: GET_ISSUES_LIST_BY_ID_SUCCESS, payload: values});
  });
  // firebaseDb.ref(`/posts/${projectId}/${issueId}`).once('value', (snapshot) => {
  //     dispatch({tye: GET_ISSUES_LIST_SUCCESS, payload: snapshot.val()});
  // })
};


async function incrementNextId(projectId) {
  let nextId;

  await firebaseDb
    .ref(`/ids/project-issues/${projectId}`)
    .transaction(function (currentValue) {
      nextId = (currentValue || 0) + 1;
      return nextId;
    });

  return nextId;
}

export const createPost = (
  projectId,
  post,
  files,
  userProfile,
  withFiles = true,
  project
) => async dispatch => {

  if (!userProfile) {
    dispatch({type: NO_USER_PROFILE});
    return;
  }

  const { members } = project;

  post.owner = {
    id: userProfile.user_id,
    displayName:
      userProfile.user_metadata && userProfile.user_metadata.displayName
        ? userProfile.user_metadata.displayName
        : null,
    avatar:
      userProfile.user_metadata && userProfile.user_metadata.avatar
        ? userProfile.user_metadata.avatar
        : null
  };

  // tagged if have master account
  const masterAccount = get(userProfile, 'user_metadata.masterAccount');

  if (masterAccount) {
    if (!post.tagged) {
      post.tagged = {};
    }
    post.tagged[masterAccount.id] = masterAccount;
  }

  if (!withFiles) {
    post.isIssue = true;
    post.createdAt = Number(new Date());
    post.issueOpener = {...post.owner};
    // post.assignTo = {...post.assignTo};
  }

  if (post.assignTo) {
    post.assignTo = Object.values(members).find((member) => member.id === post.assignTo);
  } else {
    post.assignTo = {...post.owner};
  }

  post.issueNumber = await incrementNextId(projectId);
  post.id = firebaseDb.ref("/posts/" + projectId + "/").push().key;

  Object.keys(files).forEach(function (file_id) {
    let file = files[file_id];

    file.issues.push(post.id);
    file.owner = post.owner.id;
  });

  post.images = {...files, ...post.images };

  post = removeEmpty(post);

  let updates = {};

  delete post.floorName;

  updates["posts/" + projectId + "/" + post.id] = post;

  if (post.images) {
    let newUpdates = {};

    for (const i in post.images) {
      let file = post.images[i];

      if (file.shouldSave) {
        delete file.shouldSave;

        file.issues.push(post.id);
        file.owner = post.owner.id;

        if (post.categories) {
          file.categories = post.categories;
        }

        file = removeEmpty(file);

        newUpdates["project-files/" + projectId + "/" + file.id] = file;
      }
    }

    await firebaseDb.ref().update(newUpdates);
  }

  await firebaseDb.ref().update(updates);

  updates = {};

  if (withFiles) {

    console.log('files', files);

    Object.keys(files).forEach(function (file_id) {
      updates["project-files/" + projectId + "/" + file_id] = files[file_id];
    });

    await firebaseDb.ref().update(updates);
  }

  return true;
};

export const editPost = (projectId, post, project) => async dispatch => {
  let updates = {};
  const { members } = project;

  if (post.assignTo) {
    post.assignTo = members ? Object.values(members).find((member) => member.id === post.assignTo) : post.assignTo;
  } else {
    post.assignTo = {...post.owner};
  }

  post = removeEmpty(post);
  delete post.floorName;

  if (post.images) {
    let newUpdates = {};

    for (const i in post.images) {
      let file = post.images[i];

      if (file.shouldSave) {
        delete file.shouldSave;

        file.issues.push(post.id);
        file.owner = post.owner.id;
        if (post.categories) {
          file.categories = post.categories;
        }

        file = removeEmpty(file);

        newUpdates["project-files/" + projectId + "/" + file.id] = file;
      }
    }

    await firebaseDb.ref().update(newUpdates);
  }

  updates["posts/" + projectId + "/" + post.id] = post;
  await firebaseDb.ref().update(updates);
};

export const deletePost = (issue, projectId) => async () => {
  const updates = {};
  updates[`posts/${projectId}/${issue.id}/`] = null;
  updates[`posts-deleted/${projectId}/${issue.id}/`] = issue;

  if (issue.pinnedTo) {
    const fileId = issue.pinnedTo.file.id;
    const annotationId = issue.pinnedTo.annotation.id;

    if (fileId && annotationId) {
      const path = `/project-files-annotations/${projectId}/${fileId}/${annotationId}/`;

      updates[path] = null;
    }
  }

  await firebaseDb.ref().update(updates);
};

export const setProjectId = (projectId) => async dispatch => {
  dispatch({
    type: SET_PROJECT_ID,
    payload: {projectId}
  });
};

const downloadFile = (data64, fileName) => {
  let a = document.createElement("a");
  a.href = "data:application/octet-stream;base64,"+data64;
  a.download = fileName;
  a.click();
};

export const createReport = ({ projectId, userId, issueIds, reportFormat }) => async dispatch => {
  const url = process.env.NODE_ENV === 'development' ? `http://localhost:8080/reports/issue-report-${reportFormat}` : `${search.host}/reports/issue-report-${reportFormat}`;

  dispatch({
    type: ISSUES_PDF_REQUEST
  });

  const res = await axios.post(url, {
    projectId,
    userId,
    issueIds,
  },
    {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/pdf' || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    });

  const URLd = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement('a');
  link.href = URLd;
  link.setAttribute('download', `report.${reportFormat}`);
  document.body.appendChild(link);
  link.click();


  dispatch({
    type: ISSUES_PDF_SUCCESS
  });
};
